function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgForward = function SvgForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.71 11.29-6.14-6.14a.5.5 0 0 0-.71 0l-1.44 1.44a.51.51 0 0 0 0 .71l3.18 3.18H5.5A.5.5 0 0 0 5 11v2a.5.5 0 0 0 .5.5h8.1l-3.18 3.2a.51.51 0 0 0 0 .71l1.44 1.44a.5.5 0 0 0 .71 0l6.14-6.14a1 1 0 0 0 0-1.42",
    style: {
      fillRule: "evenodd"
    },
    "data-name": "Ds back-Copy"
  })));
};
export default SvgForward;